import { render, staticRenderFns } from "./ComplaintFollow.vue?vue&type=template&id=0f6cd4ae&scoped=true&"
import script from "./ComplaintFollow.vue?vue&type=script&lang=js&"
export * from "./ComplaintFollow.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintFollow.vue?vue&type=style&index=0&id=0f6cd4ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6cd4ae",
  null
  
)

export default component.exports